import { SkillLevels } from "./SkillSimulator";

export enum SkillFlag {
    NONE = 0,
    SPELL = 1, // Active spell
    SUM = 2, // Sums with regular attack instead of replacing it
    MELEE = 4, // Requires being adjacent to target
    SELF = 8, // Can be used on self
    FRIEND = 16 // Can be used on others in group
};

export interface Skill {
    id: number;
    name: string;
    desc: string;
    stats: Record<string, string>;
    reqs: Record<string, string>;
    attrs: SkillFlag | number;
};

export enum Prof {
    WARRIOR = "w",
    PALADIN = "p",
    DANCER  = "b",
    MAGE    = "m",
    HUNTER  = "h",
    TRACKER = "t"
}


export const SkillRowCount = 7;
export type SkillTree = [number[],number[],number[],number[],number[],number[],number[]]

const requiredRowLevels = [25, 35, 50, 80, 120, 170, 230]

export function getAvailablePointsAtLevel(lvl: number) {
    return lvl - 24;
}

export function getUsedSkillPoints(levels: SkillLevels) {
    let s = 0;
    for (const id in levels) {
        s += levels[id];
    }
    return s;
}

export function getRequiredLevelForRow(i: number) {
    return requiredRowLevels[i] ?? 0;
}

export function getRequiredPointsForRow(i: number) {
    const lvl = getRequiredLevelForRow(i);
    return lvl - 25;
}

export function getMaxSkillLevel(skill: Skill) {
    // TODO: support dynamic skill levels
    return 10;
}

export interface FullSkillData {
    skills: Skill[];
    skillTrees: Record<Prof, SkillTree>
}